// Remembers which page to return to after the Discogs login round trip.
// Only same-app paths are accepted, so the redirect can't be pointed at another site.
const STORAGE_KEY = 'post_login_redirect';
const EXCLUDED = ['/login', '/callback'];

const isSafePath = path => typeof path === 'string'
  && path.startsWith('/')
  && !path.startsWith('//')
  && !path.includes('\\')
  && !EXCLUDED.some(excluded => path === excluded || path.startsWith(`${excluded}?`));

export const savePostLoginRedirect = path => {
  try {
    if (isSafePath(path)) sessionStorage.setItem(STORAGE_KEY, path);
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    // Without storage we just land on the home page
  }
};

export const takePostLoginRedirect = () => {
  try {
    const path = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return isSafePath(path) ? path : '/';
  } catch (err) {
    return '/';
  }
};
